import { createAction } from '@reduxjs/toolkit';

export const errorAction = createAction('message/errorAction');
export const initAction = createAction('message/initAction');
export const putMessageAction = createAction('message/putMessageAction');
export const receiveMessageAction = createAction('message/receiveMessageAction');
export const resetStateAction = createAction('message/resetStateAction');
export const sendMessageAction = createAction('message/sendMessageAction');
export const setAllMessagesAction = createAction('message/setAllMessagesAction');
export const setRaisedHandAction = createAction('message/setRaisedHandAction');
export const setSocketAction = createAction('message/setSocketAction');
export const setUnreadMessagesAction = createAction('message/setUnreadMessagesAction');
export const successAction = createAction('message/successAction');
